import React from 'react';
import { motion } from 'framer-motion';
export function LifestyleImage() {
  return <section className="py-16 px-4 bg-[#0C0F17]" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative overflow-hidden rounded-2xl" data-id="element-177">
          <img src="https://cdn.magicpatterns.com/uploads/vMW5cf5Y1ipWh7NuvpFP8c/ChatGPT_Image_Dec_4,_2025,_01_02_32_AM.png" alt="Person reading Decisiones Que Cambian Tu Vida on tablet" className="w-full h-auto" style={{
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
        }} data-id="element-178" />

          {/* Warm glow overlay to enhance the cozy atmosphere */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(circle at 60% 40%, rgba(207, 168, 106, 0.1), transparent 60%)'
        }} data-id="element-179" />
        </motion.div>
      </div>
    </section>;
}